<template>
    <dashboard-layout>
      <template v-if="fetchDataLoading">
        <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>
      <div class="head-text3">{{ MerchantDetails.firstname }} {{ MerchantDetails.lastname }}</div>
      <div class="subhead-text3">All business details of this merchant will be displayed here.</div>
      <div class="UserInfo-card">
        <table class="table1">
  <tr>
    <th>First Name</th>
    <th>Last Name</th>
    <th>NIN</th>
    <th>BVN</th>
    <th>Email</th>
  </tr>
  <tr>
    <td>{{ MerchantDetails.firstname }}</td>
    <td>{{ MerchantDetails.lastname }}</td>
    <td>{{ MerchantDetails.nin }}</td>
    <td>{{ MerchantDetails.bvn }}</td>
    <td>{{ MerchantDetails.email }}</td>
  </tr>
       </table>

      </div>
      <div class="big-card2">
        <div class="left-section">
            <div class="left-upper">
        <div style="font-size: 15px; color: #000; font-weight: bold; margin-left: 5px;">
            Businesses
        </div><hr>

        <div class="search-bar2">
  <div class="search-icon">
    <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon">
  </div>
  <input type="text" class="form-control ml-1" v-model="searchTerm" placeholder="Search...">
</div>
    </div>

    <div class="business-table">
      
      <table class="custom-table" 
      style=" 
      border-top: 1px solid #F5EDFC;
      cursor: pointer;">
    <tbody>
    <tr v-for="businessName in filteredBusinessNames" :key="businessName">
      <div class="business-icon2">
      <td class="business-cell"  :style="{ backgroundColor: businessBackgroundColor(businessName) }"
      @click="updateRightSectionDetails(businessName)">
        <span>{{ businessName }}</span>
        
        <img src="@/components/img/Sales_Assests/openarrow.svg" alt="Open Icon">
     
      </td>
    </div>
    </tr>
  </tbody>
  </table >
</div>
  <hr>

  <!-- <div class="add-business">
    <img src="@/components/img/Sales_Assests/addbusinessbutton.svg" style="width: 240px; height: auto; margin-left: 18px;" alt="Add Business Button">
  </div> -->
  </div>


  <div class="right-section">
    <div class="horizontal-container" style="justify-content: space-between">
    <div style="font-size: 16px; color: #000; margin-left: 5px;">
      <strong>{{ selectedBusinessDetails.name }}</strong>
        </div>


        <div @click="openMoreSettingsModal(selectedBusinessDetails.id)">
        <span class="text-left">View More Details <img src="@/components/img/Sales_Assests/moredetailsicon.svg" alt="Icon" class="icon-right">
  </span>

    </div>
      </div><hr>
        

        <!-- <div class="calendar-dropdown2">
      <select  v-model="selectedMonth" @change="updateCalendar" class="dropdown-select">
        <option v-for="(month, index) in months" :key="index" :value="index + 1" class="dropdown-select">
          {{ month }}
        </option>
      </select>

      <select v-model="selectedYear" @change="updateCalendar" class="dropdown-select">
        <option v-for="year in years" :key="year" :value="year" class="dropdown-select">
          {{ year }}
        </option>
      </select>
    </div> -->

    <div class="dashboard-cards2">
      <!-- User Card -->
      <div class="dashboard-card user-card card1-border">
        <span class="card3-header">Transaction Volume
          <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
        </span>
        <div class="card-value">{{ selectedBusinessDetails.transactionVolume }}</div>
      </div>

      <!-- Business Card -->
      <div class="dashboard-card business-card card2-border2">
        <span class="card3-header">Transaction Value
          <img class="custom-icon" src="@/components/img/Sales_Assests/ovalIcon.svg" alt="Custom Icon">
        </span>
        <div class="card-value">₦{{ formatAmount(selectedBusinessDetails.transactionValue) }}</div>
      </div>
    </div>

    <div style="font-size: 16px; color: #000; font-weight: bold; margin-left: 5px; margin-top: 30px;">
            Locations
        </div>

    <div class="search-bar3">
  <div class="search-icon">
    <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon">
  </div>
  <input type="text" class="form-control ml-1" v-model="searchTerm3"
  style="width: 520px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;"
   placeholder="Search with location name...">
</div>
<br><br>

<!-- table Section-->
<div class="table-section">
<div class="custom-table-container" :key="currentPage">
        
        <table class="custom-table">
          <thead>
            <tr>
              <th style="white-space: nowrap;">Location Name</th>
              <th>No_OF_Cashiers</th>
              <th>No_Of_POS</th>
              <th style="white-space: nowrap;">Successful Transactions</th>
              <th style="white-space: nowrap;">Incomplete/Failed Transactions</th>
              <th>Disputes</th>
              <th></th> 
            </tr>
          </thead>
          <tbody>
            <template v-if="filteredRows.length === 0">
          <tr>
            <td colspan="7" style="text-align: center;">No records found</td>
          </tr>
        </template>
            <template v-else-if="searchTerm3 && filteredRows.length > 0">
            <tr v-for="(row, index) in filteredRows" :key="index" class="table-row" @click="openLocationModal(row)">
              <td>{{ row.name }}</td>
              <td>{{ row.cashierCount }}</td>
              <td>{{ row.posCount }}</td>
              <td>{{ row.successfulTransactionsCount }}</td>
              <td>{{ row.failedTransactionsCount }}</td>
              <td>{{ row.disputedTransactionsCount }}</td>
              <td class="vertical-dots-cell">
                <!-- Vertically aligned dots -->
                <img src="@/components/img/Sales_Assests/dots.svg" 
                     alt="View Icon" 
                     style="padding-right: 10px;"
                     @click.stop="togglePopup(row)">
  
                <!-- Popup tab -->
                <div @click="openLocationModal(row)" class="popup-tab" v-show="row.showPopup">
                  <div  class="popup-item">
                    <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                         alt="eye Icon" 
                         class="popup-icon"
                         style="height: 12px; width: auto; margin-left: 2px;">
                    <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                         alt="eye Icon" 
                         class="popup-icon"
                         style="height: 12px; width: auto; margin-left: 2px;">
                    View Details
                  </div>
                  <!-- <div class="divider"></div>
                  <div @click="addBusiness(row)" class="popup-item">
                    <img v-if="!hovered" src="@/components/img/Sales_Assests/blackplus.svg" 
                         alt="plus Icon" 
                         class="popup-icon"
                         style="height: 17px; width: auto;">
                    <img v-else src="@/components/img/Sales_Assests/colorplus.svg" 
                         alt="plus Icon" 
                         class="popup-icon"
                         style="height: 17px; width: auto;">
                    Add Cashier
                  </div> -->
                </div>
              </td>
            </tr>
            </template>
            <template v-else>
             <tr v-for="(row, index) in visibleRows" :key="index" class="table-row" @click="openLocationModal(row)">
              <td>{{ row.name }}</td>
              <td>{{ row.cashierCount }}</td>
              <td>{{ row.posCount }}</td>
              <td>{{ row.successfulTransactionsCount }}</td>
              <td>{{ row.failedTransactionsCount }}</td>
              <td>{{ row.disputedTransactionsCount }}</td>
              <td class="vertical-dots-cell">
                <!-- Vertically aligned dots -->
                <img src="@/components/img/Sales_Assests/dots.svg" 
                     alt="View Icon" 
                     style="padding-right: 10px;"
                     @click.stop="togglePopup(row)">
  
                <!-- Popup tab -->
                <div @click="openLocationModal(row)" class="popup-tab" v-show="row.showPopup">
                  <div  class="popup-item nav-link">
                    <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                         alt="eye Icon" 
                         class="popup-icon"
                         style="height: 12px; width: auto; margin-left: 2px;">
                    <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                         alt="eye Icon" 
                         class="popup-icon"
                         style="height: 12px; width: auto; margin-left: 2px;">
                    View Details
                  </div>
                  <!-- <div class="divider"></div>
                  <div class="popup-item">
                    <img v-if="!hovered" src="@/components/img/Sales_Assests/blackplus.svg" 
                         alt="plus Icon" 
                         class="popup-icon"
                         style="height: 17px; width: auto;">
                    <img v-else src="@/components/img/Sales_Assests/colorplus.svg" 
                         alt="plus Icon" 
                         class="popup-icon"
                         style="height: 17px; width: auto;">
                    Add Cashier
                  </div> -->
                </div>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
       
      </div>
      <div class="pagination">
        <span>{{ currentPageStart }} - {{ currentPageEnd }} of {{ totalRows }}</span>
        <img src="@/components/img/Sales_Assests/previousbutton.svg" 
        class="pagination-icon1"
        alt="Prev Icon" 
        @click="prevPage">
        <img src="@/components/img/Sales_Assests/nextbutton.svg" 
        class="pagination-icon2"
        alt="Next Icon" 
        @click="nextPage">
      </div>
      <hr>
    </div>

  </div>
      </div>

      <account-settings-modal 
      :showMoreDetailsModal="showMoreDetailsModal"  
      :showLocationDetailsModal="showLocationDetailsModal"  
      :currentBusinessID="currentBusinessID"
      :currentMerchantID="currentMerchantID"
      @close-modal="closeMoreDetailsModal" 
    >
    </account-settings-modal >

    <add-cashier-modal 
      :showLocationDetailsModal="showLocationDetailsModal" 
      :LocationData="selectedLocationData" 
      :fetchLocationData = "fetchLocationData"
      @open-modal2="openLocationModal" 
      @close-modal2="closeLocationModal" 
      @reset-location-detail="resetFetching"
      @reload-business="reloadBusiness"
    >
    </add-cashier-modal>

    <add-location-modal 
    :AddLocationModal="AddLocationModal" 
    :BusinessID="BusinessID" 
    :BusinessName="BusinessName" 
    @close-add-location-modal="CloseAddLocationModal"
    @reload-business="reloadBusiness"
    ></add-location-modal>

    </template>

    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import AccountSettingsModal from './AccountSettingsModal.vue';
  import AddCashierModal from './AddCashierModal.vue';
  import AddLocationModal from './AddLocationModal.vue';
  import axios from 'axios'; 
  
  export default {
    name: 'Details-businesses',
  
    components: {
      DashboardLayout,
      AccountSettingsModal,
      AddCashierModal,
      AddLocationModal,
    },
  
    data() {
    return {

        showMoreDetailsModal: false,
        selectedLocationData: null,
        showLocationDetailsModal: false,
        AddLocationModal: false,
        BusinessID: null,
        BusinessName: null,
        fetchLocationData: false,
        selectedMonth: new Date().getMonth() + 1, // January is 1-based
      selectedYear: new Date().getFullYear(),
      months: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
      ],
      years: [],
    businessNames: [],
        searchTerm: '',
        selectedRowData: {},
        currentPage: 1,
        rowsPerPage: 3,
        totalRows: 0,
        searchTerm3: '',
        showPopup: Array(3).fill(false),
        userID: null,
        currentMerchantID: null,
        currentBusinessID: null,
        MerchantDetails: null,
        fetchDataLoading: true,
        selectedBusiness: null,
        selectedBusinessDetails: {},
        businessDetails: null,
        businessNameColor: null,

        tableData: [],


    };
  },
  async mounted() {
    this.userID = sessionStorage.getItem('userId');

    try{
      await this.fetchMerchantDetails();
      this.fetchDataLoading = false;
    } catch(error){
      console.log(error);
    }

    if (this.filteredBusinessNames.length > 0) {
    this.selectedBusiness = this.filteredBusinessNames[0];
    this.updateSelectedBusinessDetails();
  }

document.addEventListener('click', this.closePopups);
this.totalRows = this.tableData.length;


const currentYear = new Date().getFullYear();
for (let year = 2000; year <= 2030; year++) {
  this.years.push(year);
}
console.log(currentYear);
  },


  computed: {

    businessBackgroundColor() {
    return businessName => this.businessNameColor == businessName ? '#F7F5FF' : '';
  },


    filteredRows() {
  let filteredData = [];
  let startIndex = 0;
  let endIndex = 0;
    const term = this.searchTerm3.toLowerCase().trim();
    if (!term) return this.tableData;

    // Filter rows based on search term
    filteredData = this.tableData.filter(row =>
      Object.values(row).some(value =>
        value && value.toString().toLowerCase().includes(term)
      )
    );

    // Apply pagination to filtered rows
    startIndex = (this.currentPage - 1) * this.rowsPerPage;
    endIndex = startIndex + this.rowsPerPage;

  return filteredData.slice(startIndex, endIndex);
},

visibleRows() {
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    const endIndex = startIndex + this.rowsPerPage;
    
    // Filter rows based on search term
    const filteredRows = this.filteredRows;
    
    // Slice the filtered rows based on pagination
    return filteredRows.slice(startIndex, endIndex);
  },
  
  currentPageStart() {
  if (this.searchTerm3) {
    return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.filteredRows.length);
  } else {
    return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.totalRows);
  }
},

currentPageEnd() {
  if (this.searchTerm3) {
    return Math.min(this.currentPage * this.rowsPerPage, this.filteredRows.length);
  } else {
    return Math.min(this.currentPage * this.rowsPerPage, this.totalRows);
  }
},


  filteredBusinessNames() {
    let filteredNames = [];
    const term = this.searchTerm.toLowerCase().trim();

    if (!term) return this.businessNames;

    // Filter business names based on search term
    filteredNames = this.businessNames.filter(name =>
      name.toLowerCase().includes(term)
    );

    return filteredNames;
  }
},

  methods: {

    formatAmount(amount) {
  const parsedAmount = parseFloat(amount);

 
  if (isNaN(parsedAmount)) {
    console.error('Invalid amount:', amount);
    return ''; 
  }


  const roundedAmount = parsedAmount.toFixed(2);

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true 
  });

  return formatter.format(roundedAmount);
},

   

    async reloadBusiness(){

      await this.fetchMerchantDetails();
      this.updateSelectedBusinessDetails();

    },

    openAddLocationModal(BusinessID, BusinessName){

      this.AddLocationModal = true;
      this.BusinessID = BusinessID;
      this.BusinessName = BusinessName;

    },

    CloseAddLocationModal(){
      this.AddLocationModal = false;
    },

    resetFetching(){
      this.fetchLocationData = false;

    },

    openLocationModal(LocationData) {
      this.selectedLocationData = LocationData; 
      this.showLocationDetailsModal = true;
      this.fetchLocationData = true;
    },

    updateSelectedBusinessDetails() {
    this.selectedBusinessDetails = this.businessDetails.find(business => business.name === this.selectedBusiness);
    this.tableData = this.selectedBusinessDetails.locations;
    this.businessNameColor = this.selectedBusiness;
  },


    updateRightSectionDetails(selectedBusinessName) {
    // Find the selected business details
    const selectedBusiness = this.MerchantDetails.businesses.find(business => business.name === selectedBusinessName);
    if (selectedBusiness) {
      this.selectedBusinessDetails = selectedBusiness;
      this.tableData = this.selectedBusinessDetails.locations;
      this.businessNameColor = selectedBusinessName;
    }
  },

    async fetchMerchantDetails() {
      try {
  
        const MerchantID = this.$route.query.MID;
        const url = `${this.$config.GETMERCHANT_ENDPOINT}/merchants/${MerchantID}`;
        this.currentMerchantID = MerchantID;
        const response = await axios.get(url);
        this.MerchantDetails = response.data.data;
        this.businessDetails = response.data.data.businesses; 

         
    this.businessNames = this.MerchantDetails.businesses.map(business => business.name);

      console.log('All business names', this.businessNames);
        
        } catch (error) {
        console.error(error);
       
      }
    },

    closeLocationModal(){
        this.showLocationDetailsModal = false;

    },
  

    openMoreSettingsModal(BusinessID) {
      this.showMoreDetailsModal = true;
      this.currentBusinessID = BusinessID;
     
    },

    closeMoreDetailsModal(){
        this.showMoreDetailsModal = false;
    },

    nextPage() {
    const totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
  },
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  },



    toggleHover() {
            this.hovered = !this.hovered;
          
        },

        togglePopup(row) {
          this.tableData.forEach(row => {
        row.showPopup = false;
      });
          console.log('popup clicked', row);
    // Check if the row already has the showPopup property
    if (!Object.prototype.hasOwnProperty.call(row, 'showPopup')) {
      // If not, add it with an initial value of false
      this.$set(row, 'showPopup', false);
    }
    // Toggle the showPopup value for the corresponding row
    row.showPopup = !row.showPopup;
  },


    closePopups() {

      console.log('Close popup clicked');
      // Close all popups
      this.tableData.forEach(row => {
        row.showPopup = false;
      });
    },



    filterBusinessNames() {
    // Convert the search term to lowercase for case-insensitive matching
    const searchTerm = this.searchTerm.toLowerCase();
    
    // Filter the business names based on the search term
    this.filteredBusinessNames = this.businessNames.filter(businessName => {
      // Convert the current business name to lowercase for comparison
      const name = businessName.toLowerCase();
      
      // Return true if the business name contains the search term
      return name.includes(searchTerm);
    });
  },
  },

 
  
  };
  </script>
  
  <style scoped>

  .table-section{
    margin-top: 15px;
    max-height: 400px;
    max-width: 580px;
    overflow: auto;
  }
  .custom-table{
    overflow: auto;
  }

  .custom-table-container::-webkit-scrollbar {
  height: 6px;
  width: 6px; 
}

.custom-table-container::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; 
  border-radius: 3px;
}

.search-bar3 {
 position: relative;
  margin-top: 15px;
}

.search-bar3 input[type="text"] {
  padding-left: 30px; /* Space for the icon */
}

  .view-more{
    margin-top: 30px;
    width: 100%;
    height: 50px;
    background-color: #F8F9FC;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    transition: transform 0.3s;
    cursor: pointer;
  }
  .view-more:hover{
    transform: scale(1.02);
  }

  .text-left {
    margin-right: auto;
    color: #6F48FF;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
}

.icon-right {
    width: auto; 
    height: 19px; 
    margin-left: 10px; 
}


.oval-icon9{
    margin-left: 130px;
  }
  .oval-icon8{
    margin-left: 118px;
  }

.card2-border2{
  border-left: 1px solid #624915 ;
  border-right: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
}

.dashboard-cards2 {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  
}

.calendar-dropdown2 {
  border-radius: 5px;
  display: flex;
  margin-left: 0px;
  font-size: 12px;
  height: 25px;
  
}

  .business-table{
    max-height: 400px;
    margin-top: 40px; 
  }

  .business-table::-webkit-scrollbar {
  width: 6px; 
}

.business-table::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; 
  border-radius: 3px; 
}

  .add-business{
    
    transition: transform 0.3s;
    height: auto;
    width: 100px;
  }

  .add-business:hover{
    transform: scale(1.05);
  }

.business-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
}
.business-cell img {
  margin-left: auto;
}

.search-bar2 {
  position: relative;
}

.search-bar2 input[type="text"] {
  padding-left: 30px; /* Space for the icon */
}

.left-upper{
    padding: 15px;
}

.left-section {
 width: 300px;
  background-color: #fff;

  border-right: 1px solid #F5EDFC;
}

.right-section {
  width: 700px;
  background-color: #fff;
  padding: 15px;
  padding-left: 60px;
  padding-right: 40px;
}


.big-card2  {
    background-color: #FFF; 
    margin: 20px 40px;  
    height: 700px;
    display: flex;
  }
  .UserInfo-card {
    background-color: #F1F3F9;
    margin: 20px 40px;
    padding: 20px;
  }
  
  .table1 {
    width: 100%;
    border-collapse: collapse;

    th, td {
    padding: 2px;
    text-align: left;
  }

  td{
    font-weight: bold;
    color: #212020;
    font-size: 13px;
  }
  
  th {
    width: 5%;
    font-size: 12px;
    font-weight: normal;
  }
  }
  
  
  </style>